/* eslint-disable */ // cant worry about it rn

import Cookies from "universal-cookie";
import { BrowserRouter, useSearchParams } from "react-router-dom";
import { useEffect, useState } from "react";

import LoginPage from "./Pages/LoginPage2";
import { Routes, Route } from "react-router-dom";
import CourseListPage from "./Pages/old/CourseListPage";

import "./Styles/main.css";
import LoginStep2 from "./Components/LoginPage/LoginStep2";
import { Course, sendGetReq, sendPostReq, User } from "./Scripts/misc";
import RouterPage from "./Pages/RouterPage";

function App() {
  const cookies = new Cookies();
  let [params, setParams] = useSearchParams();

  let [token, setToken] = useState(cookies.get("token"));
  let [userData,setUserData] = useState<User | undefined>(undefined)

  const cookieSetter = async (data: string) => {
    setToken(data)
    params.set("token","")
    cookies.set("token", data, { path: "/", maxAge: 16200 });
  };

  const cookieClearer = () => {
    cookies.set("token", "", { path: "/", maxAge: 16200 })
    params.delete("token")
    setParams(params)
  }


  return (
    <>
      {!token ? (
          <LoginPage enter={cookieSetter}/>
      ) : <RouterPage token={token} clear={cookieClearer}/>}
    </>
  );
}

export default App;
